module.exports = __webpack_public_path__ + "img/Cards.7fc82301.svg";